













import { Component, Vue } from 'vue-property-decorator';
import Quotes from '@/services/Quotes';

@Component
export default class NewQuote extends Vue {
	constructor() {
		super();
	}

	private async newQuote() {
		await Quotes.newQuote();
	}
}
